<template>
    <div
        ref="dragUpload"
        class="drag-upload">
        <div
            class="btn"
            @click="onClick" />
        <p class="tip">{{ $t('Other.DragUpload.drag_and_drop') }}</p>
        <p
            v-for="(item, index) in files"
            :key="index"
            class="text-center">
            {{ $t('Other.DragUpload.fliename') }}：{{ item.name }} <br>
            {{ $t('Other.DragUpload.fliesize') }}：{{ item.size }} kb
        </p>
        <input
            type="file"
            ref="file"
            @change="onChange"
            :accept="input.accept"
            :disabled="input.disabled"
            :multiple="input.multiple">
    </div>
</template>

<script>
export default {
    props: ['value', 'disabled', 'multiple', 'accept'],
    name: 'DragUpload',
    data() {
        return {
            input: {
                accept: this.accept || 'application/vnd.ms-excel,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xlsx',
                disabled: this.disabled || false,
                multiple: this.multiple || false,
            },
            files: [],
        };
    },
    computed: {},
    created() {
        this.$nextTick(() => {
            document.addEventListener('drop', (e) => {  //拖离
                e.preventDefault();
            })
            document.addEventListener('dragleave', (e) => {  //拖后放
                e.preventDefault();
            })
            document.addEventListener('dragenter', (e) => {  //拖进
                e.preventDefault();
            })
            document.addEventListener('dragover', (e) => {  //拖来拖去
                e.preventDefault();
            })
            this.$refs.dragUpload.addEventListener('drop', this.handleDrop, false)
        });
    },
    methods: {
        onClick() {
            if (this.disabled) return;
            this.$refs.file.click();
        },
        async onChange(e) {
            this.input.disabled = true;
            const files = e.target.files;
            this.handleFiles(files);
            e.target.value = '';
            this.input.disabled = false;
        },
        handleDrop(e) {
            e.preventDefault();
            const files = e.dataTransfer.files;
            // 检测是否是拖拽文件到页面的操作
            if (!files.length) return false;
            this.handleFiles(files);
        },
        handleFiles(files) {
            for (const file of files) {
                this.files.push({
                    name: file.name,
                    size: file.size / 1000
                });
                this.$emit('input', file);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    .drag-upload {
        position: relative;
        margin: 50px auto;
        width: 680px;
        height: 345px;
        border: 3px dashed #d2d2d2;
        border-radius: 5px;
        box-sizing: border-box;
        .btn {
            margin: 100px auto 20px;
            width: 76px;
            height: 96px;
            cursor: pointer;
            position: relative;
            z-index: 1;
            background: url(../../assets/images/import_icon_excel.png) left top no-repeat;
        }
        .tip {
            font-size: 14px;
            text-align: center;
        }
        > input {
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 0;
            padding: 0;
            margin: 0;
            z-index: -1;
            display: none;
            -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
        }
    }
</style>
